import OutcomeQuestionConfiguration from "./OutcomeQuestionConfiguration";

export default OutcomeQuestionConfiguration;
